/**
 * Crypt Pawn Color Schemes
 *
 * Gradient-based color schemes for the crypt pawn design.
 * Each scheme defines color-specific gradients (body ball, eye rings, neck section)
 * while neutral colors (silver head, face features, dark inner area) are shared
 * across all variants.
 */

export interface CryptPawnColorScheme {
  /** Unique name used as gradient ID prefix to avoid SVG collisions */
  name: string;

  /** Primary body gradient stop 0 (dark shade of player color) */
  bodyPrimary: string;

  /** Primary body gradient stop 1 (light shade of player color) */
  bodySecondary: string;
}

export const CRYPT_PAWN_COLOR_SCHEMES: Record<string, CryptPawnColorScheme> = {
  blue: {
    name: 'blue',
    bodyPrimary: '#0071BC',
    bodySecondary: '#29ABE2'
  },
  red: {
    name: 'red',
    bodyPrimary: '#C1272D',
    bodySecondary: '#F15A24'
  },
  yellow: {
    name: 'yellow',
    bodyPrimary: '#F7931E',
    bodySecondary: '#FCEE21'
  },
  green: {
    name: 'green',
    bodyPrimary: '#007741',
    bodySecondary: '#04AE58'
  }
};
